package com.devi3east.bashbuddy.account.profile.requests

import com.devi3east.bashbuddy.common.domain.models.Address
import kotlinx.serialization.Serializable

@Serializable
data class UpdateProfileRequest(
    val displayName: String,
    val name: String? = null,
    val phone: String,
    val profileImageUrl: String? = null,
    val address: Address?,
    val showCartInfoDialog: Boolean? = null,
    val showFirstSignInDialog: Boolean? = null,
    val isActive: Boolean? = null,
    val affiliatedOrganization: String? = null
)